document.addEventListener("DOMContentLoaded", function () {
  var chargebee = Chargebee.init({
    site: "nomad-internet",
    iframeOnly: true
  });
});

const initializeChargebeeProductTracking = (dropInLinkId, planName, content_ids, coupon_id) => {
  const cbInstance = Chargebee.getInstance();

  if (!cbInstance) {
    return;
  }

  const checkoutElement = document.getElementById(dropInLinkId);
  const product = cbInstance.getProduct(checkoutElement);

  product.data["cf_Device_IMEI"] = "pending";
  product.data["cf_SIM_ID_ICCID"] = "pending";

  if (coupon_id) product.addCoupon(coupon_id);
}
